import { type FormEvent, useEffect, useState } from 'react'
import { api, type Profil as ProfilDaten } from '../api'
import { Fehlermeldung, fehlerText } from './gemeinsam'

export function Profil() {
  const [profil, setProfil] = useState<ProfilDaten | null>(null)
  const [fehler, setFehler] = useState<string | null>(null)

  const laden = () => api.profil().then(setProfil).catch((e) => setFehler(fehlerText(e)))
  useEffect(() => {
    laden()
  }, [])

  return (
    <div className="zweispaltig gleich">
      <section className="karte">
        <h2>E-Mail-Adresse</h2>
        <Fehlermeldung fehler={fehler} />
        {profil && <EmailFormular profil={profil} onGeaendert={laden} />}
      </section>
      <section className="karte">
        <h2>Passwort ändern</h2>
        <PasswortFormular />
      </section>
    </div>
  )
}

function EmailFormular({ profil, onGeaendert }: { profil: ProfilDaten; onGeaendert: () => void }) {
  const [email, setEmail] = useState('')
  const [fehler, setFehler] = useState<string | null>(null)

  async function absenden(e: FormEvent) {
    e.preventDefault()
    setFehler(null)
    try {
      await api.emailAendern(email)
      setEmail('')
      onGeaendert()
    } catch (err) {
      setFehler(fehlerText(err))
    }
  }

  return (
    <form className="formular" onSubmit={absenden}>
      <p>
        {profil.email ? (
          <>
            {profil.email}
            <span className="marke">{profil.emailVerifiziert ? 'bestätigt' : 'nicht bestätigt'}</span>
          </>
        ) : (
          <span className="hinweis">Keine E-Mail-Adresse hinterlegt. Ohne bestätigte Adresse ist kein Passwort-Reset möglich.</span>
        )}
      </p>
      {profil.ausstehendeEmail && (
        <p className="hinweis">
          Bestätigungslink an {profil.ausstehendeEmail} verschickt. Die neue Adresse gilt, sobald du den Link aufgerufen hast.
        </p>
      )}
      <label>
        {profil.email ? 'Neue E-Mail-Adresse' : 'E-Mail-Adresse'}
        <input type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} />
      </label>
      <Fehlermeldung fehler={fehler} />
      <div className="knoepfe">
        <button type="submit" className="primaer" disabled={!email}>
          Bestätigungslink senden
        </button>
      </div>
    </form>
  )
}

function PasswortFormular() {
  const [aktuell, setAktuell] = useState('')
  const [neu, setNeu] = useState('')
  const [wiederholung, setWiederholung] = useState('')
  const [fehler, setFehler] = useState<string | null>(null)
  const [erfolg, setErfolg] = useState(false)

  async function absenden(e: FormEvent) {
    e.preventDefault()
    setFehler(null)
    setErfolg(false)
    if (neu !== wiederholung) return setFehler('Die neuen Passwörter stimmen nicht überein.')
    try {
      await api.passwortAendern(aktuell, neu)
      setAktuell('')
      setNeu('')
      setWiederholung('')
      setErfolg(true)
    } catch (err) {
      setFehler(fehlerText(err))
    }
  }

  return (
    <form className="formular" onSubmit={absenden}>
      <label>
        Aktuelles Passwort
        <input type="password" autoComplete="current-password" value={aktuell} onChange={(e) => setAktuell(e.target.value)} />
      </label>
      <label>
        Neues Passwort (mindestens 10 Zeichen)
        <input type="password" autoComplete="new-password" value={neu} onChange={(e) => setNeu(e.target.value)} />
      </label>
      <label>
        Neues Passwort wiederholen
        <input type="password" autoComplete="new-password" value={wiederholung} onChange={(e) => setWiederholung(e.target.value)} />
      </label>
      <Fehlermeldung fehler={fehler} />
      {erfolg && <p>Das Passwort wurde geändert.</p>}
      <div className="knoepfe">
        <button type="submit" className="primaer" disabled={!aktuell || !neu}>
          Passwort ändern
        </button>
      </div>
    </form>
  )
}
